import React, { PropTypes } from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import { onDrop } from "../attachments/S3UploaderHelper";

const S3FileInput = (props, context) => {
  const {
    input,
    label,
    meta: { error, touched },
    dropzoneLabel,
    groupClassName,
    id,
    list,
    uploaderProps,
    ...rest
  } = props;
  const validationState = !!error && touched ? error.state : null;
  const validationMessageKey =
    !!error && error.messageKey ? error.messageKey : null;
  const validationValues = !!error && error.values ? error.values : null;
  const scene = context.scene ? "-" + context.scene : "";

  return (
    <FormGroup
      className={[groupClassName, "file-input", "s3-file-input"]}
      controlId={id + scene}
      validationState={validationState}
    >
      {label && <ControlLabel>{label}</ControlLabel>}
      <div>
        <DropzoneS3Uploader
          id={name}
          name={name}
          onDrop={(filesToUpload) => {
            onDrop(filesToUpload);
            input.onFocus();
            input.onBlur(filesToUpload);
            return input.onChange(filesToUpload);
          }}
          {...uploaderProps}
          {...rest}
        >
          <div>
            <p className="description">
              <span className="icon icon-out" />
              <FormattedMessage
                id={dropzoneLabel || "attachments.attachmentDescription"}
              />
            </p>
            {list(false)}
          </div>
        </DropzoneS3Uploader>
        {error && touched && (
          <HelpBlock>
            <FormattedMessage
              id={validationMessageKey}
              values={validationValues}
            />
          </HelpBlock>
        )}
      </div>
    </FormGroup>
  );
};

S3FileInput.propTypes = {
  dropzoneLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  isStatic: PropTypes.bool,
  list: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.object.isRequired,
  uploaderProps: PropTypes.object.isRequired,
  validation: PropTypes.object,
  validationKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default S3FileInput;



// WEBPACK FOOTER //
// ./src/components/common/form/S3FileInput.js